import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";

import { FlashcardContentSkeleton } from "./FlashcardContentSkeleton";

const RoundedSkeleton = styled(MUISkeleton)`
	border-radius: 12px;
	transform: unset;
`;

const BarSkeleton = styled(MUISkeleton)`
	flex: 1;
	border-radius: 5px;
	transform: unset;
`;

interface FlashcardsSkeletonProps {
	className?: string;
}

function FlashcardsSkeleton({ className }: FlashcardsSkeletonProps) {
	return (
		<div className={className}>
			<div className="creator-container">
				<div className="creator--box basic-box">
					<div className="flashcard--deck--info">
						<div className="flashcard--deck--info--top">
							<MUISkeleton
								variant="circular"
								width={28}
								height={28}
								className="flashcard--deck--info--icon"
							/>
							<RoundedSkeleton
								variant="rounded"
								height={32}
								className="flashcard--deck--info--name"
							/>
							<RoundedSkeleton variant="rounded" width={200} height={40} />
							<MUISkeleton
								variant="circular"
								width={40}
								height={40}
								className="flashcard--deck--info--close"
							/>
						</div>
						<div className="flashcard--deck--info--progress">
							<RoundedSkeleton variant="rounded" width={90} height={20} />
							<BarSkeleton variant="rounded" height={10} />
							<RoundedSkeleton variant="rounded" width={32} height={20} />
						</div>
					</div>
					<div className="flashcard-app--content--box">
						<FlashcardContentSkeleton />
					</div>
				</div>
			</div>
		</div>
	);
}

export default FlashcardsSkeleton;
